import { checkArray } from '../../../../Components/helper';
import useSinglePackedUnits from './useSinglePackedUnits';

export default function useMultiTypePackedUnits() {
  const {
    calcDiffSize,
    calcDiffLength,
    // calcQuanity,
    limitTofourDecimal,
    toDec,
  } = useSinglePackedUnits();

  const calculateMultiPackedUnits = async (data) => {
    const cloneMultiSizePackedUnit = data;
    if (checkArray(cloneMultiSizePackedUnit?.multipleTotalPackedRows)) {
      cloneMultiSizePackedUnit.totalSize = calcDiffSize(cloneMultiSizePackedUnit?.multipleTotalPackedRows);
      cloneMultiSizePackedUnit.totalLength = calcDiffLength(cloneMultiSizePackedUnit?.multipleTotalPackedRows);

      cloneMultiSizePackedUnit.totalDiscountPerUnit = calcDiscPrice(cloneMultiSizePackedUnit?.multipleTotalPackedRows);
      cloneMultiSizePackedUnit.totalPackRatio = await calcPackRatio(cloneMultiSizePackedUnit?.multipleTotalPackedRows);

      const multipleTotalPack = {
        totalPackRatio: cloneMultiSizePackedUnit.totalPackRatio,
        totalPacks: cloneMultiSizePackedUnit.totalPacks,
      };
      cloneMultiSizePackedUnit.totalUnits = await calcTotalMultiplePacks(multipleTotalPack);
      cloneMultiSizePackedUnit.totalPriceBeforeDisc = calcBeforePrice(cloneMultiSizePackedUnit?.multipleTotalPackedRows, multipleTotalPack);

      if (cloneMultiSizePackedUnit?.multipleTotalPackedRows) {
        for (const singular of cloneMultiSizePackedUnit.multipleTotalPackedRows) {
          const persentageValue = (Number(singular?.beforeDiscPrice) * Number(singular?.discount || 0)) / 100;
          singular.afterDiscPrice = singular?.beforeDiscPrice - persentageValue;
        }
      }
      cloneMultiSizePackedUnit.totalPriceAfterDisc = calcAfterPrice(cloneMultiSizePackedUnit?.multipleTotalPackedRows, multipleTotalPack);
    }
    return cloneMultiSizePackedUnit;
  };

  function calcBeforePrice(packedRows, multipleTotalPack) {
    const brforePricesTotals = packedRows.map((row) => {
      const priceBeforeDisc = row.beforeDiscPrice && !isNaN(row.beforeDiscPrice) ? parseFloat(row.beforeDiscPrice) : 0;
      let quantity = 0;
      const destiUnits = row.packRatio && !isNaN(row.packRatio) ? parseFloat(row.packRatio) : 0;
      const totalPacks = multipleTotalPack && !isNaN(multipleTotalPack.totalPacks) ? parseFloat(multipleTotalPack.totalPacks) : 0;
      quantity = multipleTotalPack ? totalPacks * destiUnits : quantity;
      return toDec(priceBeforeDisc * quantity);
    });
    const beforePrice = brforePricesTotals
      .map((row) => row)
      .reduce((a, b) => {
        return parseFloat(a) + parseFloat(isNaN(b) ? 0 : b);
      }, 0);
    return isNaN(beforePrice) ? 0 : limitTofourDecimal(beforePrice);
  }

  function calcDiscPrice(packedRows) {
    let discountCnt = packedRows.filter((row) => row.discount && row.discount !== '' && Number(row.discount) !== 0);
    discountCnt = discountCnt.map((val) => String(val.discount));
    discountCnt = [...new Set(discountCnt)];
    discountCnt = discountCnt?.length || 0;
    return discountCnt;
  }

  function calcAfterPrice(packedRows, multipleTotalPack) {
    const afterPricesTotals = packedRows.map((row) => {
      let priceAfterDisc = 0;

      if (row?.afterDiscPrice && !isNaN(row?.afterDiscPrice)) {
        priceAfterDisc = parseFloat(row.afterDiscPrice);
      } else if (row?.beforeDiscPrice && !isNaN(row?.beforeDiscPrice)) {
        priceAfterDisc = parseFloat(row.beforeDiscPrice);
      }

      const destiUnits = row?.packRatio && !isNaN(row?.packRatio) ? parseFloat(row?.packRatio) : 0;
      const totalPacks = multipleTotalPack && !isNaN(multipleTotalPack.totalPacks) ? parseFloat(multipleTotalPack.totalPacks) : 0;
      let quantity = 0;
      quantity = multipleTotalPack ? totalPacks * destiUnits : quantity;
      return toDec(priceAfterDisc * quantity);
    });
    const price = afterPricesTotals
      .map((row) => row)
      .reduce((a, b) => {
        return parseFloat(a) + parseFloat(isNaN(b) ? 0 : b);
      }, 0);
    return isNaN(price) ? 0 : limitTofourDecimal(price);
  }

  async function calcPackRatio(packedRows) {
    const rowQuantity = packedRows
      .map((row) => row.packRatio)
      .reduce((a, b) => {
        return Number(a) + Number(isNaN(b) ? 0 : b);
      }, 0);
    return isNaN(rowQuantity) ? 0 : rowQuantity;
  }

  async function calcTotalMultiplePacks(multipleTotalPack) {
    const rowQuantity = Number(multipleTotalPack.totalPackRatio) * Number(multipleTotalPack.totalPacks);
    return isNaN(rowQuantity) ? 0 : rowQuantity;
  }

  return {
    calculateMultiPackedUnits,
  };
}
